import { ContentContainerType } from 'types/enums';
import { ChakraPageTitle, ContentContainer } from 'app/components/Core';
import React from 'react';
import { routes } from 'app/routing/routesConfig';
import { NavTabs } from 'app/components/Core/ChakraNavTabs';
import { useChatFeatureFlag } from 'featureFlags';
import { Navigate } from 'react-router-dom';
import { ChatChannelsList } from 'app/components/Chat/ChatChannelsList';
import { useAppSelector } from 'app/store';
import { getNewNotificationsCounts } from 'app/store/Notifications/selectors';

export const Messages = () => {
  const notificationsCounts = useAppSelector(getNewNotificationsCounts);
  const { chatFeatureEnabled } = useChatFeatureFlag();

  if (!chatFeatureEnabled) {
    return <Navigate to={routes.notifications.path} />;
  }

  return (
    <ContentContainer type={ContentContainerType.LIST} pt={6} pb={24}>
      <ChakraPageTitle pb={6}>Activity</ChakraPageTitle>
      <NavTabs
        variant="soft-rounded"
        routes={[routes.notifications, routes.messages]}
        counts={{
          [routes.notifications.name]: notificationsCounts.activityCount,
          [routes.messages.name]: notificationsCounts.unreadChatMessagesCount,
        }}
        mb={8}
      />
      <ChatChannelsList />
    </ContentContainer>
  );
};
